import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import Toasted from 'vue-toasted';
import vueSelect from 'vue-select';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-select/dist/vue-select.css';

Vue.use(vueSelect);
Vue.use(BootstrapVue);
Vue.use(Toasted);

Vue.prototype.$toFixed = function toFixed(num) {
  const with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
  return with2Decimals;
}

Vue.prototype.$showError = function displayError(message) {
  const errOptions = {
    duration: 3000
  }
  if(Array.isArray(message)) {
    message.forEach(msg => {
      this.$toasted.error(msg, errOptions);
    })
  }
  else {
    this.$toasted.error(message, errOptions);
  }
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
